import React from "react";

export type TComponentRef =
  | "h1"
  | "h2"
  | "h3"
  | "h4"
  | "h5"
  | "h6"
  | "p"
  | "div"
  | "span";
export interface DynamicRefComponentProps {
  componentRef: TComponentRef;
  className?: string; // to style with styled components
}

const DynamicRefComponent: React.FC<DynamicRefComponentProps> = ({
  componentRef,
  className,
  children,
}) => {
  const Component = componentRef;

  return <Component className={className}>{children}</Component>;
};

export default DynamicRefComponent;
